"use client";

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { css, cx } from "styled-system/css";

const nav = [
  { href: "/admin", label: "Global" },
  { href: "/admin/planes", label: "Planes y cuentas" },
  { href: "/admin/landing-plans", label: "Planes web" },
  { href: "/admin/discount-codes", label: "Códigos de descuento" },
  { href: "/admin/referral-codes", label: "Códigos de referido" },
  { href: "/admin/announcements", label: "Avisos" },
  { href: "/admin/notifications", label: "Historial" },
  { href: "/admin/access-logs", label: "Historial de accesos" },
  { href: "/admin/tickets", label: "Tickets" },
  { href: "/admin/settings", label: "Plataforma" },
  { href: "/admin/costs", label: "Costos" },
];

export function AdminNav() {
  const { pathname } = useLocation();
  const [pendingHref, setPendingHref] = useState<string | null>(null);

  useEffect(() => {
    setPendingHref(null);
  }, [pathname]);

  return (
    <nav className={css({ display: "flex", flexDir: "column", gap: "1.5" })} aria-busy={pendingHref != null}>
      {nav.map((item) => {
        const isActive =
          pathname === item.href || (item.href !== "/admin" && pathname.startsWith(item.href));
        const isPendingNav = pendingHref === item.href;
        const highlighted = isActive || isPendingNav;

        return (
          <Link
            key={item.href}
            to={item.href}
            onClick={() => {
              if (!isActive) setPendingHref(item.href);
            }}
            className={cx(
              css({
                fontSize: "sm",
                py: "2.5",
                px: "3",
                rounded: "md",
                borderWidth: "1px",
                borderColor: "transparent",
                color: "rgba(255,255,255,0.72)",
                transition: "background-color 120ms ease, border-color 120ms ease, color 120ms ease",
                _hover: { bg: "rgba(255,255,255,0.08)", color: "white" },
              }),
              highlighted &&
                css({
                  bg: "rgba(255,255,255,0.12)",
                  borderColor: "rgba(255,255,255,0.18)",
                  color: "white",
                  fontWeight: "semibold",
                }),
              isPendingNav &&
                !isActive &&
                css({
                  opacity: 0.92,
                }),
            )}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
